import { EAccountSubscriptionPlans } from './account.type'

export interface IBillingModalFormValues {
  months: number
  method: EPaymentMethod
  subscription_plan: EAccountSubscriptionPlans
}

export enum EPaymentMethod {
  Card,
  Crypto,
}
